<script>
  export default {
    name: 'MenuItem',
    functional: true,
    props: {
      icon: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      badge: {
        type: Number,
        default: null
      }
    },
    render(h, context) {
      const { icon, title, badge } = context.props
      const vnodes = []
      if (icon) {
        if (icon.includes('el-icon')) {
          vnodes.push(<i class={[icon, 'sub-el-icon']} />)
        } else {
          vnodes.push(<svg-icon icon-class={icon}/>)
        }
      }
      if (title) {
        vnodes.push(<span slot='title'>{(title)}</span>)
      }
      if (badge) {
        vnodes.push(<el-badge slot="title" value={badge}></el-badge>)
      }
      return vnodes;
    }
  }
</script>

<style scoped>
  .sub-el-icon {
    color: currentColor;
    width: 1em;
    height: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/Item.vue